<template>
  <pt-notes-dialog :hasRead="hasRead" @submitRepurchaseIntention="submitRepurchaseIntention" @submit="submit" @cancel="cancel" :notesDetail="notesDetail" v-loading="notesLoading" class="pt-notes-dialog__withData"></pt-notes-dialog>
</template>

<script>
import PtNotesDialog from './index'
export default {
  name: 'pt-notes-dialog__withData',
  components: {
    'pt-notes-dialog': PtNotesDialog
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    hasRead: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      notesLoading: false,
      notesDetail: {}
    }
  },
  methods: {
    signNotesDetail () {
      this.notesLoading = true
      this.$store.dispatch('signNotesDetail', this.id).then(res => {
        this.notesLoading = false
        this.notesDetail = res
      }).catch(err => {
        this.notesLoading = false
        this.$message.error(err || '获取报名记录详情失败')
      })
    },
    submit (val) {
      this.notesLoading = true
      let api = this.notesDetail.workflowStatus === 'INTERPRETED' ? 'addAdditionalReadDetail' : 'addReadDetail'
      this.$store.dispatch(api, val).then(res => {
        this.$message.success('录入解读详情成功')
        this.notesLoading = false
        this.$emit('onCancel')
      }).catch(errorMessage => {
        this.$message.error(errorMessage || '录入解读详情失败')
        this.notesLoading = false
      })
    },
    submitRepurchaseIntention (val) {
      this.notesLoading = true
      this.$store.dispatch('repurchaseIntention', val).then(res => {
        this.$message.success('选择复购意向成功')
        this.notesLoading = false
        this.$emit('onCancel')
      }).catch(errorMessage => {
        this.$message.error(errorMessage || '录选择复购意向失败')
        this.notesLoading = false
      })
    },
    cancel () {
      this.$emit('onCancel')
    }
  },
  created () {
    this.signNotesDetail()
  }
}
</script>
